import {
    FormControl,
    Checkbox,
    FormGroup,
    Typography,
    Box,
    FormHelperText,
} from '@mui/material';
import { FormikProps } from 'formik';
import { FormValues } from '../FormPagePerson';

const Agreement = ({ formik }: { formik: FormikProps<FormValues> }) => {
    const firm = !window.location.hostname.includes('brandlift') ? "Sparky B" : "Brandlift";
    const privacy_policy = !window.location.hostname.includes('brandlift') ? "www.sparkyb.pl/polityka-prywatnosci" : "www.brandlift.pl/polityka-prywatnosci";
    return (
        <Box mt={10} >
            <FormGroup>
                <FormControl
                    error={formik.touched.dataAgreement && Boolean(formik.errors.dataAgreement)}
                    sx={{ mb: 2 }}
                >
                    <Box display="flex">
                        <Box>
                            <Checkbox 
                                key="dataAgreement"
                                name="dataAgreement"
                                checked={formik.values.dataAgreement}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                sx={{
                                    p: 0.5,
                                    ...(formik.touched.dataAgreement && formik.errors.dataAgreement
                                        ? {
                                            color: 'error.main',
                                            '&.Mui-checked': { color: 'error.main' },
                                        }
                                        : {
                                            color: 'primary.main',
                                            '&.Mui-checked': { color: 'primary.main' },
                                        }),
                                }}
                            />
                        </Box>
                        <Box ml={1}>
                            <Typography variant="body1">
                                Oświadczam, że dane zawarte w kwestionariuszu są zgodne ze stanem rzeczywistym i zobowiązuję się do niezwłocznego poinformowania {firm} sp. z o.o. o ich każdorazowej zmianie.
                            </Typography>
                        </Box>
                    </Box>
                    {formik.touched.dataAgreement && formik.errors.dataAgreement && (
                        <FormHelperText>{formik.errors.dataAgreement}</FormHelperText>
                    )}
                </FormControl>
                {/* Checkbox 2 */}
                <FormControl
                    error={
                        formik.touched.personalDataProcessingConsent &&
                        Boolean(formik.errors.personalDataProcessingConsent)
                    }
                    sx={{ mb: 2 }}
                >
                    <Box display="flex">
                        <Box>
                            <Checkbox
                                                            key="personalDataProcessingConsent"

                                name="personalDataProcessingConsent"
                                checked={formik.values.personalDataProcessingConsent}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                sx={{
                                    p: 0.5,
                                    ...(formik.touched.personalDataProcessingConsent &&
                                        formik.errors.personalDataProcessingConsent
                                        ? {
                                            color: 'error.main',
                                            '&.Mui-checked': { color: 'error.main' },
                                        }
                                        : {
                                            color: 'primary.main',
                                            '&.Mui-checked': { color: 'primary.main' },
                                        }),
                                }}
                            />
                        </Box>
                        <Box ml={1}>
                            <Typography variant="body1">
                                Wyrażam zgodę na przetwarzanie przez {firm} sp. z o.o. moich danych osobowych
                                podanych w kwestionariuszu w celu zawarcia i wykonania umowy zawartej z {firm} sp.
                                z o.o.
                            </Typography>
                        </Box>
                    </Box>
                    {formik.touched.personalDataProcessingConsent &&
                        formik.errors.personalDataProcessingConsent && (
                            <FormHelperText>{formik.errors.personalDataProcessingConsent}</FormHelperText>
                        )}
                </FormControl>

                {/* Checkbox 3 */}
                <FormControl
                    error={
                        formik.touched.privacyPolicyAcknowledgment &&
                        Boolean(formik.errors.privacyPolicyAcknowledgment)
                    }
                    sx={{ mb: 2 }}
                >
                    <Box display="flex">
                        <Box>
                            <Checkbox
                                key="privacyPolicyAcknowledgment"
                                name="privacyPolicyAcknowledgment"
                                checked={formik.values.privacyPolicyAcknowledgment}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                sx={{
                                    p: 0.5,
                                    ...(formik.touched.privacyPolicyAcknowledgment &&
                                        formik.errors.privacyPolicyAcknowledgment
                                        ? {
                                            color: 'error.main',
                                            '&.Mui-checked': { color: 'error.main' },
                                        }
                                        : {
                                            color: 'primary.main',
                                            '&.Mui-checked': { color: 'primary.main' },
                                        }),
                                }}
                            />
                        </Box>
                        <Box ml={1}>
                            <Typography variant="body1">
                                Zapoznałem/am się z zasadami przetwarzania danych osobowych przez {firm} sp. z o.o.
                                zawartych w Polityce Prywatności dostępnej na stronie{' '}
                                <a
                                    href={`https://${privacy_policy}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Polityka prywatności serwisu {firm}
                                </a>
                            </Typography>
                        </Box>
                    </Box>
                    {formik.touched.privacyPolicyAcknowledgment &&
                        formik.errors.privacyPolicyAcknowledgment && (
                            <FormHelperText>{formik.errors.privacyPolicyAcknowledgment}</FormHelperText>
                        )}
                </FormControl>
            </FormGroup>

            {/* Informacja o przetwarzaniu danych */}

            <Box mt={4}>
                <Typography variant="body2" color="textSecondary">
                        {firm === "Sparky B" ? (
                                <>
                                    Administratorem danych osobowych jest Sparky B Spółka z ograniczoną odpowiedzialnością z
                                    siedzibą w Warszawie, pod adresem ul. Domaniewska 37, 02-672 Warszawa, wpisana do Rejestru
                                    Przedsiębiorców Krajowego Rejestru Sądowego, sąd rejestrowy: Sąd Rejonowy dla m.st.
                                    Warszawy, XII Wydział KRS, pod numerem KRS 0001028723, NIP: 5273051826, REGON: 525042360.
                                    Podanie danych jest dobrowolne. Szczegółowe zasady przetwarzania danych osobowych przez
                                    Sparky B sp. z o.o. zawarte są w Polityce Prywatności dostępnej na stronie{' '}
                                    <a
                                        href="https://www.sparkyb.pl/polityka-prywatnosci"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Polityka prywatności serwisu Sparky B
                                    </a>
                                    .
                                </>
                            ) : (
                                <>
                                    Administratorem danych osobowych jest Brandlift Spółka z ograniczoną odpowiedzialnością
                                    z siedzibą w Warszawie, pod adresem ul. Domaniewska 37, 02-672 Warszawa, wpisana do
                                    Rejestru Przedsiębiorców Krajowego Rejestru Sądowego, sąd rejestrowy: Sąd Rejonowy dla m.st.
                                    Warszawy, XII Wydział KRS, pod numerem KRS 0001028723, NIP: 5272893049, REGON: 383333621.
                                    Podanie danych jest dobrowolne. Szczegółowe zasady przetwarzania danych osobowych przez
                                    Brandlift sp. z o.o. zawarte są w Polityce Prywatności dostępnej na stronie{' '}
                                    <a
                                        href="https://brandlift.pl/polityka-prywatnosci/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Polityka prywatności serwisu BrandLift
                                    </a>
                                    .
                                </>
                        )}
                </Typography>
            </Box>
        </Box>
    );
};

export default Agreement;
